export const ORIGIN_LABELS = { manual: ["manuale", "bg-emerald-100 text-emerald-800"], import: ["da import", "bg-sky-100 text-sky-800"], legacy: ["adottato", "bg-amber-100 text-amber-800"] };

export function formatCfValue(def, v) {
  if (v === null || v === undefined || v === "") return "";
  if (Array.isArray(v)) return v.join(", ");
  if (!def) return String(v);
  if (def.type === "boolean") return v === true || String(v).toLowerCase() === "true" ? "Sì" : "No";
  if (def.type === "date") { const d = new Date(String(v)); return isNaN(d) ? String(v) : d.toLocaleDateString("it-IT"); }
  if (def.type === "number") return typeof v === "number" ? v.toLocaleString("it-IT") : String(v);
  return String(v);
}

export const COLS_KEY = "wa_contacts_cf_cols";
export const readCols = () => { try { return JSON.parse(localStorage.getItem(COLS_KEY) || "[]"); } catch { return []; } };
export const writeCols = (keys) => localStorage.setItem(COLS_KEY, JSON.stringify(keys));
